import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const Grid = props => {
  return /*#__PURE__*/_jsx("div", {
    className: "ms-Grid",
    dir: props.dir,
    children: props.children
  });
};
Grid.defaultProps = {
  dir: 'ltr'
};